module.exports = __webpack_public_path__ + "static/media/file-invoice.7e06b47b.svg";